module.exports = __webpack_public_path__ + "static/media/marker-icon-green.fd617c65.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/css/images/marker-icon-green.png
 ** module id = 861
 ** module chunks = 0
 **/